import { Grid, Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import { Trans, useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { EaContext } from 'src/contexts/EaContext';
import { SkillsTechnicalContext } from 'src/contexts/SkillsTechnicalContext';
import { SkillsMetierFonctionnelleContext } from 'src/contexts/SkillsMetierFonctionnelleContext';
import { SkillsManagerialeContext } from 'src/contexts/SkillsManagerialeContext';
import { SkillsBehaviorContext } from 'src/contexts/SkillsBehaviorContext';
import { SkillsLinguistiqueContext } from 'src/contexts/SkillsLinguistiqueContext';
import { ActionContext } from 'src/contexts/ActionContext';
import { BusinessManagerContext } from 'src/contexts/BusinessManagerContext';
import { EEPLanguageContext } from 'src/contexts/EEPLanguageContext';

function DialogWarningEEP(props) {
	const {
		isUserHimSelf,
		hasManagerPermission
	} = useContext(ActionContext);
	const {
		isDCUpToDateData,
		interviewDateNManagerKO,
		mobilityDataKO,
		trainingReportDataKO,
		evaluationCompetenceNm1DataKO,
		objectifNPlus1DataKO
	} = useContext(EaContext);
	const { skillsTechnicalDataKO } = useContext(SkillsTechnicalContext);
	const { skillsMetierFonctionnelleDataKO } = useContext(SkillsMetierFonctionnelleContext);
	const { skillsManagerialeDataKO } = useContext(SkillsManagerialeContext);
	const { skillsBehaviorDataKO } = useContext(SkillsBehaviorContext);
	const { skillsLinguistiqueDataKO } = useContext(SkillsLinguistiqueContext);
	const {
		BDSkillsDataKO,
		SCSkillsDataKO,
		RCSkillsDataKO,
		MHSkillsDataKO,
		GCSkillsDataKO,
		POSkillsDataKO,
		BMSkillsDataKO,
		CMSkillsDataKO,
		EPSkillsDataKO
	} = useContext(BusinessManagerContext);
	const {
		EEPLanguageDataKO
	} = useContext(EEPLanguageContext);
	const { t } = useTranslation();
	const displayWarning = props.displayWarning;
	const handleCloseWarning = props.handleCloseWarning;

	return (
		<Dialog open={displayWarning} maxWidth={'md'} fullWidth>
			<DialogTitle style={{ fontSize: 20, paddingBottom: 8, paddingTop: 8, backgroundColor: 'red', color: '#FFF' }}>
				<Grid container direction="row">
					<Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
						<WarningIcon style={{ fontSize: 20 }} />
						&nbsp;&nbsp;{t('warning')}
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent style={{ paddingBottom: 5, paddingTop: 5 }}>
				<Grid container direction="row" alignItems="stretch" spacing={1} >
					{isUserHimSelf && props.EEPBM &&
						<Grid item xs={12} style={{ fontSize: 18, fontWeight: 500 }}>
							<p><Trans>warningVerifyData.message</Trans></p>
							{mobilityDataKO && <p><Trans>eepBm.warning.mobilityDataKO</Trans></p>}
							{/* For skills data */}
							{BDSkillsDataKO && <p><Trans>eepBm.warning.BDSkillsDataKO</Trans></p>}
							{SCSkillsDataKO && <p><Trans>eepBm.warning.SCSkillsDataKO</Trans></p>}
							{RCSkillsDataKO && <p><Trans>eepBm.warning.RCSkillsDataKO</Trans></p>}
							{MHSkillsDataKO && <p><Trans>eepBm.warning.MHSkillsDataKO</Trans></p>}
							{GCSkillsDataKO && <p><Trans>eepBm.warning.GCSkillsDataKO</Trans></p>}
							{POSkillsDataKO && <p><Trans>eepBm.warning.POSkillsDataKO</Trans></p>}
							{BMSkillsDataKO && <p><Trans>eepBm.warning.BMSkillsDataKO</Trans></p>}
							{CMSkillsDataKO && <p><Trans>eepBm.warning.CMSkillsDataKO</Trans></p>}
							{EPSkillsDataKO && <p><Trans>eepBm.warning.EPSkillsDataKO</Trans></p>}
							{EEPLanguageDataKO && <p><Trans>eepBm.warning.EEPLanguageDataKO</Trans></p>}
							{/* For skills data */}
							<p><Trans>warningVerifyData.warningMessage</Trans></p>
						</Grid>
					}
					{hasManagerPermission && props.EEPBM &&
						<Grid item xs={12} style={{ fontSize: 18, fontWeight: 500 }}>
							<p><Trans>warningVerifyData.message</Trans></p>
							{interviewDateNManagerKO && <p><Trans>eepBm.warning.interviewDateNManagerKO</Trans></p>}
							{/* For skills data */}
							{BDSkillsDataKO && <p><Trans>eepBm.warning.BDSkillsDataKO</Trans></p>}
							{SCSkillsDataKO && <p><Trans>eepBm.warning.SCSkillsDataKO</Trans></p>}
							{RCSkillsDataKO && <p><Trans>eepBm.warning.RCSkillsDataKO</Trans></p>}
							{MHSkillsDataKO && <p><Trans>eepBm.warning.MHSkillsDataKO</Trans></p>}
							{GCSkillsDataKO && <p><Trans>eepBm.warning.GCSkillsDataKO</Trans></p>}
							{POSkillsDataKO && <p><Trans>eepBm.warning.POSkillsDataKO</Trans></p>}
							{BMSkillsDataKO && <p><Trans>eepBm.warning.BMSkillsDataKO</Trans></p>}
							{CMSkillsDataKO && <p><Trans>eepBm.warning.CMSkillsDataKO</Trans></p>}
							{EPSkillsDataKO && <p><Trans>eepBm.warning.EPSkillsDataKO</Trans></p>}
							{EEPLanguageDataKO && <p><Trans>eepBm.warning.EEPLanguageDataKO</Trans></p>}
							{/* For skills data */}
							<p><Trans>warningVerifyData.warningMessage</Trans></p>
						</Grid>
					}
					{isUserHimSelf && !props.EEPBM &&
						<Grid item xs={12} style={{ fontSize: 18, fontWeight: 500 }}>
							<p><Trans>warningVerifyData.message</Trans></p>
							{isDCUpToDateData != 1 && <p><Trans>warningVerifyData.checkedIsDCUpToDate</Trans></p>}
							{skillsTechnicalDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsTechnicalConsultant</Trans></p>}
							{skillsMetierFonctionnelleDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsMetierFonctionnelleConsultant</Trans></p>}
							{skillsManagerialeDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsManagerialeConsultant</Trans></p>}
							{skillsBehaviorDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsBehaviorConsultant</Trans></p>}
							{skillsLinguistiqueDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsLinguistiqueConsultant</Trans></p>}
							{mobilityDataKO && <p><Trans>warningVerifyData.mobilityField</Trans></p>}
							{trainingReportDataKO && <p><Trans>warningVerifyData.evaluationTrainingReport</Trans></p>}
							<p><Trans>warningVerifyData.warningMessage</Trans></p>
						</Grid>
					}
					{hasManagerPermission && !props.EEPBM &&
						<Grid item xs={12} style={{ fontSize: 18, fontWeight: 500 }}>
							<p><Trans>warningVerifyData.message</Trans></p>
							{interviewDateNManagerKO && <p><Trans>warningVerifyData.interviewDateNManager</Trans></p>}
							{skillsTechnicalDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsTechnicalManager</Trans></p>}
							{skillsMetierFonctionnelleDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsMetierFonctionnelleManager</Trans></p>}
							{skillsManagerialeDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsManagerialeManager</Trans></p>}
							{skillsBehaviorDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsBehaviorManager</Trans></p>}
							{skillsLinguistiqueDataKO && <p><Trans>warningVerifyData.evaluationFieldSkillsLinguistiqueManager</Trans></p>}
							{evaluationCompetenceNm1DataKO && <p><Trans>warningVerifyData.evaluationCompetenceData</Trans></p>}
							{trainingReportDataKO && <p><Trans>warningVerifyData.evaluationTrainingReport</Trans></p>}
							{objectifNPlus1DataKO && <p><Trans>warningVerifyData.objectifData</Trans></p>}
							<p><Trans>warningVerifyData.warningMessage</Trans></p>
						</Grid>
					}
				</Grid>
			</DialogContent>
			<DialogActions style={{ justifyContent: "flex-start", paddingLeft: 24, paddingBottom: 16 }}>
				<Button
					onClick={handleCloseWarning}
					style={{ minWidth: 100, backgroundColor: 'black', color: 'white' }}
				>
					<Trans>ok</Trans>
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default DialogWarningEEP;